import { loadStripe } from '@stripe/stripe-js';

// Get Stripe publishable key from environment variables
const stripePublishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;

// Validate Stripe key
if (!stripePublishableKey || stripePublishableKey === 'your_stripe_publishable_key') {
  console.warn('Stripe publishable key is missing or using placeholder. Payment features will be disabled.');
}

// Initialize Stripe only if we have a valid key
export const stripePromise = stripePublishableKey && stripePublishableKey !== 'your_stripe_publishable_key' 
  ? loadStripe(stripePublishableKey)
  : null;

// Function to create a payment intent (would call your backend)
export const createPaymentIntent = async (amount: number, currency: string = 'inr') => {
  try {
    if (!stripePromise) {
      throw new Error('Stripe is not configured. Please set VITE_STRIPE_PUBLISHABLE_KEY in your environment variables.');
    }

    // In a real app, this would call your backend API endpoint
    // which would then use Stripe's API to create a payment intent
    
    // For demo purposes, we'll simulate a successful response
    console.log(`Creating payment intent for ${amount} ${currency}`);
    
    // Simulate API call
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    // Return a mock payment intent
    return {
      clientSecret: 'pi_mock_secret_' + Math.random().toString(36).substring(2, 15),
      amount,
      currency
    };
  } catch (error) {
    console.error('Error creating payment intent:', error);
    throw error;
  }
};

// Function to process a payment
export const processPayment = async (invoiceId: string, amount: number) => {
  try {
    if (!stripePromise) {
      throw new Error('Stripe is not configured. Please set VITE_STRIPE_PUBLISHABLE_KEY in your environment variables.');
    }

    // In a real app, this would call your backend API
    console.log(`Processing payment for invoice ${invoiceId} of amount ${amount}`);
    
    // Simulate API call
    await new Promise(resolve => setTimeout(resolve, 1500));
    
    // Return a mock payment result
    return {
      success: true,
      paymentId: 'py_' + Math.random().toString(36).substring(2, 15),
      amount
    };
  } catch (error) {
    console.error('Error processing payment:', error);
    throw error;
  }
};

// Helper function to check if Stripe is available
export const isStripeAvailable = () => {
  return !!stripePromise;
};